import {get, post} from '../index'
export default{
  // 获取所有名片列表
  getBusinessCardAllList (querys) {
    return get('/card/admin/users', querys)
  },
  // 获取员工名片列表
  getBusinessCardStaffList (querys) {
    return get('/card/admin/staffs', querys)
  },
  // 取消名片
  cancelStaffCard (querys) {
    return post('/card/admin/cancelStaff', querys)
  },
  // 设置员工 名片 / boss / 推荐
  settingStaffCard (querys) {
    return post('/card/admin/setStaff', querys)
  },
  // 名片编辑页面数据回显
  staffCardInfo (querys) {
    return get('/card/admin/staffInfo', querys)
  },
  // 生成新的小程序码
  creatNewStaffQr (querys) {
    return post('/card/admin/reCreateStaffQr', querys)
  },
  // 编辑员工名片
  editStaffCard (querys) {
    return post('/card/admin/editStaff', querys)
  },
  // 获取印象标签列表
  getTagList (querys) {
    return get('/card/admin/tags', querys)
  },
  // 获取boss权限分配
  getBossAuthInfo (querys) {
    return get('/card/admin/authBossInfo', querys)
  },
  // 设置BOSS权限
  settingBossAuth (querys) {
    return post('/card/admin/editAuthBoss', querys)
  },
  // 添加、编辑标签
  editOrAddTag (querys) {
    return post('/card/admin/editTag', querys)
  },
  // 上下架、删除标签
  updateTag (querys) {
    return post('/card/admin/updateTag', querys)
  },
  // 免审口回显令、编辑
  editExemptionPwd (querys) {
    return post('/card/admin/getAuthCode', querys)
  },
  // 手机端设置、回显
  editMobile (querys) {
    return post('/card/admin/getPhoneCreate', querys)
  },
  // 名片设置、回显
  editOrGetCardInfo (querys) {
    return post('/card/admin/getCardSetting', querys)
  },
  // 媒体设置、回显
  editOrGetMedia (querys) {
    return post('/card/admin/getDefaultMedia', querys)
  },
  // 获取所有的员工
  getAllStaffs (querys) {
    return get('/card/admin/staffs?limit=100000', querys)
    // return get('/card/admin/ListAllStaff')
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/businessCard.js